import React, { useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import './form.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faQrcode,
  faHouse,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';

export default function Payment() {
  const [params] = useSearchParams();
  const qrCode = params.get('qr') || '';
  const qrUrl = params.get('qrUrl') || '';
  const name = params.get('name') || '';
  const email = params.get('email') || '';
  const passes = params.get('passes') || '1';

  useEffect(() => { AOS.init({ duration: 600, once: true }); }, []);

  return (
    <div className="jm-result-page">
      <div className="jm-result-card" data-aos="zoom-in">
        <div className="jm-result-icon-wrap">
          <div className="jm-result-icon success">
            <FontAwesomeIcon icon={faCircleCheck} />
          </div>
        </div>

        <div className="jm-result-body">
          <h2>Payment Successful!</h2>
          <p>
            {name ? `Thank you, ${name}!` : 'Thank you!'} Your registration for
            <strong> Jaisalmer — The Aurelia Mirage</strong> is confirmed.
            {passes !== '1' && <> ({passes} passes)</>}
            {email && <> A confirmation has been sent to <strong>{email}</strong>.</>}
          </p>
        </div>

        {qrUrl && (
          <div className="jm-qr-section" data-aos="fade-up" data-aos-delay="200">
            <div className="jm-qr-wrap">
              <FontAwesomeIcon icon={faQrcode} style={{ fontSize: '1.2rem', color: 'var(--jm-secondary)' }} />
              <img src={qrUrl} alt="Entry QR Code" />
              {qrCode && (
                <p style={{ fontSize: '0.7rem', color: 'var(--jm-muted)', margin: '0.5rem 0 0' }}>
                  Code: <strong>{qrCode}</strong>
                </p>
              )}
              <p style={{ fontSize: '0.78rem', color: 'var(--jm-muted)', margin: 0 }}>
                Show this QR code at the venue for entry
              </p>
            </div>
          </div>
        )}

        <div className="jm-result-body">
          <div className="jm-result-actions">
            <Link to="/" className="jm-rbtn primary">
              <FontAwesomeIcon icon={faHouse} />
              Back to Home
            </Link>
            {email && (
              <a href={`mailto:${email}`} className="jm-rbtn outline">
                <FontAwesomeIcon icon={faEnvelope} />
                Check Email
              </a>
            )}
          </div>
        </div>

        <div className="jm-result-foot">
          <p>Keep your QR code safe — you'll need it for event entry. For any issues, contact <a href="mailto:rcaiitkgp.payment@gmail.com">rcaiitkgp.payment@gmail.com</a></p>
        </div>
      </div>
    </div>
  );
}
